<template lang="pug">
#toolbar(:class="{ 'apiTop': whiteLabel }")
  a#open-left(v-if="!whiteLabel" href="javascript:void(0);" @click="toggle()")
    img(src="/images/nav-icon.svg")
  router-link#logo-swipe.logo(v-if="!whiteLabel" to="/lobby")
    img(v-if="cnyMode" :src="logoCNYPath")
    img(v-else-if="xmasMode" :src="logoXMASPath")
    img(v-else :src="logoPath")
  //- .userpart(:class="{ 'apiHeader': whiteLabel }")
  //-   .username-wrapper
  //-     .username
  //-       .user-id {{ displayName }}
  //-     .balance
  //-       span.currency.mr-1 {{ currency_code }}
  //-       span {{ available_balance }}
  //-   .user-icon
  //-     i.fas.fa-user
  .userpart(v-if="whiteLabel")
    .username
      .user-id {{ displayName }}
    .balance
      span.currency.mr-1 {{ currency_code }}
      span {{ available_balance }}
  .userpart(v-else)
    .username-wrapper
      .username
        .user-id {{ displayName }}
      .balance
        span.currency.mr-1 {{ currency_code }}
        span {{ available_balance }}
    .user-icon
      i.fas.fa-user
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";
import ClickOutside from "vue-click-outside";
import config from "@/config";

export default {
  directives: {
    ClickOutside
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    logoPath() {
      return config.logoPath;
    },
    cnyMode() {
      return config.cnyMode;
    },
    xmasMode() {
      return config.xmasMode;
    },
    logoCNYPath() {
      return config.logoCNYPath;
    },
    logoXMASPath() {
      return config.logoXMASPath;
    },
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    displayName() {
      if (this.nickname) return this.nickname;
      else return this.account_id;
    },
    account_id() {
      return this.$store.getters.accountId;
    },
    nickname() {
      return this.$store.getters.nickName;
    },
    wallet() {
      if (this.$store.getters.playerWallet) return this.$store.getters.playerWallet;
      return null;
    },
    balance() {
      return this.$store.getters.balance;
    },
    currency_code() {
      if (this.wallet["currency_code"]) {
        return this.wallet.currency_code.replace('UST', 'USDT');
      }
      return "-";
    },
    available_balance() {
      if (this.wallet) {
        return this.$numeral(this.balance).format("0,0.[00]");
      }
      return "-";
    }
  },
  destroyed() {
    EventBus.$off("GET_BALANCE", this.busGetBalance);
    clearInterval(this.populateBalance);
  },
  mounted() {
    this.populateBalance();
    setInterval(this.populateBalance, 60000);
    EventBus.$on("GET_BALANCE", this.busGetBalance);
    EventBus.getBalance = this.busGetBalance;
  },
  methods: {
    lobby() {},
    busGetBalance() {
      clearInterval(this.populateBalance);
      this.populateBalance();
    },
    toggle(e) {
      var body = $("body");
      var casinoMenu = $("#casino");

      if (!casinoMenu.hasClass("show")) {
        casinoMenu.addClass("show");
      }

      if (!body.hasClass("snapjs-left")) {
        body.addClass("snapjs-left");
      } else {
        body.removeClass("snapjs-left");
      }
    },
    hide(e) {
      var body = $("body");
      if (body.hasClass("snapjs-left")) {
        body.removeClass("snapjs-left");
      }
    },
    populateBalance(callback) {
      if (this.loading == true) return;
      if (this.isLoggedIn) {
        this.loading = true;
        this.$store.dispatch("user/getBalance").then(
          res => {
            this.loading = false;
            if (res.success) {
              if (callback) callback();
            } else {
              if (this.$helpers.handleFeedback(res.status)) {
                if (callback) callback();
              }
            }
          },
          err => {
            this.loading = false;
            if (this.$helpers.handleFeedback(err.status)) {
              if (callback) callback();
            }
          }
        );
      }
    }
  }
};
</script>
